import Vue from "vue";
import {
  onChildAdded,
  onChildChanged,
  onChildRemoved
} from "firebase/database";

// import { firebaseAction } from "vuexfire";

import api from "../utils/fbApi";

export default {
  namespaced: true,
  state: {
    currentLantern: {},
    chats: {},
    chatCounts: {},
    users: []
  },
  mutations: {
    SET_CHATS: (state, payload) => {
      state.chats = payload.chats;
    },
    APPEND_CHATS: (state, payload) => {
      const currentChatDocs = state.chats.docs;
      const newChatDocs = [...payload.chats.docs, ...currentChatDocs];
      payload.chats.docs = newChatDocs;
      state.chats = payload.chats;
      // Vue.set(state.chats,payl)
    },
    SET_USERS: (state, payload) => {
      state.users = payload;
    },
    ADD_CHAT: (state, payload) => {
      state.chats.docs.unshift(payload);
    },
    UPDATE_CHAT: (state, payload) => {
      Vue.set(state.chats.docs, payload.index, payload.chat);
    },
    updateChatCount: (state, payload) => {
      Vue.set(state.chatCounts, payload.key, payload.data);
    },
    deleteChatCount: (state, payload) => {
      Vue.delete(state.chatCounts, payload.key);
    }
  },
  actions: {
    getToken() {
      return api.get(`conversation/token`);
    },
    getHome(context) {
      return api.get(`conversation/home`).then(response => {
        context.commit("SET_USERS", response.users);
      });
    },
    get(context, payload) {
      return api
        .get(`conversation/list/?page=${payload.page}&status=${payload.status}`)
        .then(response => {
          if (payload.page == "1") {
            context.commit("SET_CHATS", {
              chats: response.chats
            });
          } else {
            context.commit("APPEND_CHATS", {
              chats: response.chats
            });
          }

          return response.chats;
        })
        .catch(error => console.log(error));
    },
    getChat(context, payload) {
      return api
        .get(`conversation/get/${payload.conversationId}`)
        .then(response => response.chat);
    },
    getThreads(context, payload) {
      return api
        .get(
          `conversation/threads/${payload.conversationId}?page=${payload.page}`
        )
        .then(response => response.threads);
    },
    sendChat(context, payload) {
      return api.post(
        `conversation/get/${payload.conversationId}`,
        payload.requestParams
      );
    },
    acceptChat(context, payload) {
      return api.post(`conversation/accept/${payload.conversationId}`);
    },
    getNextChat(context, payload) {
      return api.get(`conversation/next/${payload.conversationId}`);
    },
    getPreviousChat(context, payload) {
      return api.get(`conversation/prev/${payload.conversationId}`);
    },
    getCustomer(context, payload) {
      return api.get(`conversation/customer?phone=${payload.phoneNumber}`);
    },
    getNotificationSettings() {
      return api.get(`notification/config`);
    },
    updateNotificationSettings(context, payload) {
      return api.put(`notification/config`, payload.requestParams);
    },
    putAction(context, payload) {
      return api.post(
        `conversation/action/${payload.conversationId}`,
        payload.requestParams
      );
    },
    searchProducts(context, payload) {
      return api.post(`conversation/products`, payload.requestParams);
    },
    updateNotificationToken(context, payload) {
      return api.post(`notification/token`, payload.requestParams);
    },

    getCounts(context, chatCountRef) {
      onChildAdded(chatCountRef, data => {
        const snapshot = data.val();
        const key = data.key;
        context.commit("updateChatCount", { data: snapshot, key });
      });

      onChildChanged(chatCountRef, data => {
        const snapshot = data.val();
        const key = data.key;
        context.commit("updateChatCount", { data: snapshot, key });
      });

      onChildRemoved(chatCountRef, data => {
        const key = data.key;
        context.commit("deleteChatCount", { key });
      });
    }
    // firebaseAction(({ bindFirebaseRef }, { ref }) => {
    //   bindFirebaseRef("chatCounts", ref);
    // })
  },
  getters: {
    getChats: state => state.chats,
    getChatCounts: state => state.chatCounts || {},
    getUsers: state => state.users,
    getUserNameById: state => id => {
      // const currentUser = state.user;
      // if (currentUser.id === id) {
      //   return "You";
      // }
      const existingUser = state.users.find(user => user.id === id);
      if (existingUser) {
        if (existingUser.lastName) {
          return `${existingUser.firstName} ${existingUser.lastName}`;
        }
        return existingUser.firstName;
      }
      return "Anyone";
    }
  }
};
